import { APP_BASE_HREF } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import { CustomRouteReuseStrategy } from './custom-route-reuse-strategy';
import { CategoryMatcher } from './category/category-matcher';
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { ConfirmEmailComponent } from "./confirm-email/confirm-email.component";
// Customer area is lazy-loaded to reduce initial bundle size
import { HomepageComponent } from "./homepage/homepage.component";
import { NotFoundComponent } from "./not-found/not-found.component";
import { ProductMatcher } from './product/product-matcher';
// Location finder is lazy-loaded to reduce initial bundle size
import { NewsletterComponent } from "./newsletter/newsletter.component";

let routes: Routes = []

routes = routes.concat([
  {
    path: '',
    component: HomepageComponent,
    data: { hideBreadcrumbs: true },
  },
  // Customer-Links
  {
    path: 'customer',
    loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule),
    data: { label: "Kundenbereich", hideBreadcrumbs: true },
  },
  // Change Password Page
  {
    path: 'change_password',
    component: ChangePasswordComponent,
  },
  // E-Mail confirm page
  {
    path: 'confirm_email',
    component: ConfirmEmailComponent,
  },
  // Checkout (lazy-loaded module to reduce initial bundle size)
  {
    path: 'checkout',
    loadChildren: () => import('./checkout/checkout.module').then(m => m.CheckoutModule),
    data: { label: "Kassa" },
  },
  {
    path: 'checkout-success',
    loadChildren: () => import('./checkout/success/success.module').then(m => m.CheckoutSuccessModule),
    data: { label: "Bestellung erhalten" },
  },
  {
    path: 'newsletter-abonnieren',
    component: NewsletterComponent,
    data: { label: "Publikationen" },
  },
  {
    path: 'filialen',
    loadChildren: () => import('./location-finder/location-finder.module').then(m => m.LocationFinderModule),
    data: { label: "Filialen" },
  },
  {
    path: 'filiale/:slug',
    redirectTo: 'filialen/:slug',
  },
  // Product-Links
  {
    matcher: (url) => {
      return ProductMatcher.match(url)
    },
    loadChildren: () => import('./product/product.module').then(m => m.ProductModule),
    data: { matomoDisableRouteTracking: true }
  },
  // Category-Pages (lazy-loaded)
  {
    matcher: (url) => {
      return CategoryMatcher.match(url)
    },
    loadChildren: () => import('./category/category.module').then(m => m.CategoryModule),
    data: { matomoDisableRouteTracking: true }
  },
  { path: '**', component: NotFoundComponent }
]);

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/shop' },
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy }
  ]
})
export class AppRoutingModule { }
